var React = require('react');

function CreditCard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 432a48 48 0 0 0 48 48h480a48 48 0 0 0 48-48V256H0zm192-68a12 12 0 0 1 12-12h136a12 12 0 0 1 12 12v40a12 12 0 0 1-12 12H204a12 12 0 0 1-12-12zm-128 0a12 12 0 0 1 12-12h72a12 12 0 0 1 12 12v40a12 12 0 0 1-12 12H76a12 12 0 0 1-12-12zM528 32H48A48 48 0 0 0 0 80v48h576V80a48 48 0 0 0-48-48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M576 256H0V128h576z","className":"fa-primary","key":2})]);
}

CreditCard.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = CreditCard;

CreditCard.default = CreditCard;
